// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@a-type/ui';
import { useAppInfo, useLocalStorage } from '../react.js';
export function PrereleaseWarning({}) {
    const app = useAppInfo();
    const [dismissed, setDismissed] = useLocalStorage('dismissedPrereleaseWarning', false);
    if (!app.prerelease || dismissed || !import.meta.env.DEV) {
        return null;
    }
    return (_jsxs("div", { className: "bg-attention-light color-black row p-1 text-xxs items-center justify-center", children: [_jsx(Icon, { name: "warning" }), _jsxs("span", { children: [app.name, " is an unreleased", ' ', _jsx("a", { target: "_blank", rel: "noreferrer", href: "https://biscuits.club", className: "underline", children: "Biscuits" }), ' ', "app. It may be unstable or incomplete, and your data may be lost."] }), _jsx(Icon, { name: "x", role: "button", tabIndex: 0, onClick: () => setDismissed(true) })] }));
}
//# sourceMappingURL=PrereleaseWarning.js.map